import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the reciprocal square root of a single-precision floating-point number.
*
* @module @stdlib/math/base/special/rsqrtf
*
* @example
* var rsqrtf = require( '@stdlib/math/base/special/rsqrtf' );
*
* var v = rsqrtf( 4.0 );
* // returns 0.5
*
* v = rsqrtf( 0.0 );
* // returns 0.0
*
* v = rsqrtf( Infinity );
* // returns 0.0
*
* v = rsqrtf( -4.0 );
* // returns NaN
*
* v = rsqrtf( NaN );
* // returns NaN
*/

// MODULES //
var rsqrtf = __var_0__;


// EXPORTS //
export default rsqrtf;
